import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import IconEmail from "./icon-email.svg";
import { Container, Summary, Title, TitleAndSummaryContainer } from "./styles";

export const SummaryDisplay: React.FunctionComponent = () => {
  const { newsletterItemForDisplay } = useNewsletterContext();

  return (
    <Container>
      <TitleAndSummaryContainer>
        <Title>
          <IconEmail />
          NEWSLETTER
        </Title>
        <Summary>{newsletterItemForDisplay?.summary?.text}</Summary>
      </TitleAndSummaryContainer>
    </Container>
  );
};

SummaryDisplay.displayName = "SummaryDisplay";
